export default __webpack_public_path__ + "static/media/le_croise4.304b5a9d.jpg";